export default __webpack_public_path__ + "static/media/techspace2.5abfae23.PNG";